import { useSelector } from 'react-redux';

// The collapsed contents bar on narrow screens.
export const BAR_HEIGHT = 54;

// What the public site pins above the page: its sticky header, 84px wide and
// 68px narrow. Signed in, nothing is pinned; the side menu floats 24px from
// the top, which the contents line up with.
const PUBLIC_ASIDE_TOP = 100;
const PUBLIC_BAR_TOP = 76;
const APP_ASIDE_TOP = 24;
const APP_BAR_TOP = 16;

/**
 * Where the tutorial's sticky contents pin, and how far below the top a
 * jumped-to section lands: under the contents card's top on wide screens,
 * under the pinned bar on narrow ones. Both depend on whether the user is
 * signed in, as only the public site has a sticky header.
 */
export default function useTutorialOffsets(wide = true) {
    const loggedIn = useSelector((state) => Boolean(state.profile && state.profile.loggedIn));
    const asideTop = loggedIn ? APP_ASIDE_TOP : PUBLIC_ASIDE_TOP;
    const barTop = loggedIn ? APP_BAR_TOP : PUBLIC_BAR_TOP;
    const scrollOffset = wide ? asideTop : barTop + BAR_HEIGHT + 16;
    return { asideTop, barTop, scrollOffset };
}
